import { Controllers, DocumentMetadata } from "../models";
import { SearchResult } from "../models/search-result";
import { BaseClient } from "./baseClient";
import { IDocumentMetadataApi } from "./document-metadata-v2";

export class DoumentMetadataApi extends BaseClient implements IDocumentMetadataApi {
  private readonly resource: Controllers;

  constructor() {
    const useV2 =
      process.env.REACT_APP_WEBLOCATIE === "true" && Boolean(process.env.REACT_APP_METADATA_API_ENDPOINT_V2);
    super(
      new Headers({
        "Content-type": "application/json",
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
        Expires: "0",
      }),
      (useV2 ? process.env.REACT_APP_METADATA_API_ENDPOINT_V2 : process.env.REACT_APP_METADATA_API_ENDPOINT) as string
    );
    this.resource = useV2 ? "publicaties" : "metadata";
  }

  createMetadataSession = async (meta: DocumentMetadata): Promise<{ uploadUrl: string; pid: string }> => {
    const body = {
      document: meta.document,
      documentrelaties: meta.documentrelaties ?? [],
    };

    const { json } = await this.api<DocumentMetadata>(this.resource, undefined, "POST", body);

    if (!json) throw new Error("error");

    const pid = json.document.pid as string;
    const id = pid.split("/").pop()!;

    const uploadUrl = `${process.env.REACT_APP_DOCUMENT_API_ENDPOINT}/documenten/${id}`;

    return { uploadUrl, pid };
  };

  updateMetadata = async (meta: DocumentMetadata, id: string, redenId?: string) => {
    const body = {
      document: meta.document,
      documentrelaties: meta.documentrelaties ?? [],
      ...(redenId ? { infoWijziging: { redenVerwijderingVervanging: redenId } } : {}),
    };

    const { json } = await this.api<DocumentMetadata>(this.resource, id, "PUT", body);

    if (!json) throw new Error("Error");

    return json;
  };

  fetchMetadata = async (id: string, _hoofddocId?: string) => {
    const { json } = await this.api<DocumentMetadata>(this.resource, id, "GET");

    if (!json) throw new Error("Error");

    return json as DocumentMetadata;
  };

  getDocumentBijlages = async (id: string) => {
    const { json } = await this.api<DocumentMetadata[]>(this.resource, id, "GET", undefined, undefined, "/bijlagen");

    if (!json) throw new Error("Error");

    return json as SearchResult[];
  };

  depubliceerMetadata = async (id: string, redenId: string) => {
    return await this.api<DocumentMetadata>(this.resource, id, "DELETE", {
      infoVerwijdering: { redenVerwijderingVervanging: redenId },
    });
  };
}
